// extracted by mini-css-extract-plugin
module.exports = {"tab":"TabBar-module__tab--1paY_","selectedTab":"TabBar-module__selectedTab--2Cxk0","tabBar":"TabBar-module__tabBar--t7fyP"};